import { secureGet } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getRedeemRequestHistoryData = async (panelistId: number, page: number) => {
  return secureGet("/api/survey/getZampliaSurveysClaimRequest", { panelistId, page, requestType: "Study", panel: "ZampliaSurveys" });
};

export const getLoopClaimedSurveysData = async (panelListId: number, id: any) => {
  return secureGet("/api/survey/getLoopClaimedSurveys", { type: "byRequestId", panelListId, id });
};

export const VirtualBalance = async (panelListId: number) => {
  return secureGet("/api/survey/virtualWallet", { panelListId });
};

export const PointsBalance = async (panelListId: number) => {
  return secureGet("/api/survey/getPointsBalance", { panelListId });
};